export const FLOAT_BUTTON_CONFIG = {
  variant: 'extended',
  'aria-label': 'check-in',
  'data-testid': 'float-button-check-in',
}
export const FLOAT_BUTTON_BADGE_CONFIG = {
  color: 'primary',
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
}
export const FLOAT_BUTTON_MIN_VISIBLE_PX = 100

export const FLOAT_BUTTON_STORAGE_CONFIG = {
  checkInPosition: 'checkInPosition',
}

export const FLOAT_BUTTON_BADGE_COUNTER_MAX = 999

export const FLOAT_BUTTON_DRAG_PRECISION = 1

export const NEW_CHECKIN_STATUSES = {
  SUCCESS: 'success',
  FAIL: 'fail',
  VALID_CHECK_IN: 'validCheckin',
  VALID_CHECK_IN_WITH_ALERTS: 'validCheckinWithAlerts',
  INVALID_CHECK_IN: 'inValidCheckin',
  DEFAULT_NO_CHECKIN: 'defaultNoCheckin',
}
